<template>
  <div ref="map" id="map" />
</template>

<script>
import { latLong } from '../../util/enums'
import oms from 'npm-overlapping-marker-spiderfier/lib/oms.min'
import { mapLoader } from '@/util/mapLoader'

export default {
  name: 'MapGoogle',
  computed: {
    omsmarkes: {
      get() {
        return this.$store.state.dashboard.omsmarkes
      },
      set(valor) {
        this.$store.commit('dashboard/setOmsmarkes', valor)
      },
    },
    google: {
      get() {
        return this.$store.state.dashboard.google
      },
      set(valor) {
        this.$store.commit('dashboard/setGoogle', valor)
      },
    },
    googleMap: {
      get() {
        return this.$store.state.dashboard.mapgoogle
      },
      set(valor) {
        this.$store.commit('dashboard/setMapgoogle', valor)
      },
    },
  },

  mounted() {
    this.renderMap()
  },

  methods: {
    destroyMap() {
      this.googleMap = []
      this.google = []
    },

    renderMap() {
      this.destroyMap()
      if (!process.env.VUE_APP_GOOGLE_MAPS_API_KEY) throw new Error('Please provide google maps api key')

      mapLoader
        .load()
        .then((google) => {
          const country = localStorage.getItem('user_country') ?? 'BR'

          this.google = google
          this.googleMap = new google.maps.Map(this.$refs.map, {
            zoom: 5,
            center: latLong[country],
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
          })

          this.omsmarkes = new oms.OverlappingMarkerSpiderfier(this.googleMap, {
            markersWontMove: true,
            markersWontHide: true,
            keepSpiderfied: true,
            spiralFootSeparation: 35,
            spiralLengthFactor: 4.5,
            spiralLengthStart: 17,
            nearbyDistance: 20,
            legWeight: 0,
          })
        })
    },
  },
}
</script>
